import React from "react";
import "../Messages.css";
import { Chat_content } from "../MessagesInterfaces";

interface ChatProps {
  chat_content: Chat_content;
  onClick: () => void;
}

export const Chat: React.FC<ChatProps> = ({ chat_content, onClick }) => {
  const mostRecentMessage =
    chat_content.messages[chat_content.messages.length - 1];
  const IconComponent = chat_content.icon as React.FunctionComponent<
    React.SVGProps<SVGSVGElement>
  >;

  const timestamp = mostRecentMessage.timestamp; // assuming this is a timestamp
  const date = new Date(timestamp);
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const day = days[date.getDay()];
  const month = date.toLocaleString("default", { month: "short" });

  const formattedDate = `${day} ${date.getDate()} ${month}`; // This will give you a string in the format "Sun 26 May"

  return (
    <div className="chat-list-container" onClick={onClick}>
      <div className="chat-list-dot-container">
        {chat_content.read ? (
          <div className="chat-list-dot-true" />
        ) : (
          <div className="chat-list-dot-false" />
        )}
      </div>
      {typeof chat_content.icon === "string" ? (
        <img src={chat_content.icon} alt="icon" className="chat-list-icon" />
      ) : (
        <IconComponent className="chat-list-icon" />
      )}
      <div className="chat-list-content">
        <div className="chat-list-header">
          <h2 className="chat-list-name">{chat_content.name}</h2>
          <p className="chat-list-date">{formattedDate}</p>
        </div>
        <p className="chat-list-message">
          {mostRecentMessage.content.type === "text"
            ? mostRecentMessage.content.content
            : ""}{" "}
        </p>
      </div>
    </div>
  );
};

export default Chat;
